export default "__VITE_ASSET__a8f7be12__"